import dynamic from "next/dynamic";

const WrapGlobe = dynamic(import("./mapGlobe"), { ssr: false });
const WrapGlobeMobile = dynamic(import("./mapGlobeMobile"), { ssr: false });
const WrapGlobeAirFreight = dynamic(import("./mapGlobeAirFreight"), {
	ssr: false,
});

export { WrapGlobe, WrapGlobeMobile, WrapGlobeAirFreight };
